import { toLabelValue } from '@/common/convertToDropdownOptions';
import { DropdownOption } from '@/common/getDropdownList';
import { Form, useForm } from '@/components/forms';
import Input from '@/components/forms/Input';
import Select from '@/components/forms/Select';
import Textarea from '@/components/forms/Textarea';
import { useDynamicLocale } from '@/hoslog-intl';
import { z } from 'zod';
import { useRoleMutation } from './hooks/useRoleMutation';

const addRoleModalSchema = z.object({
  roleType: z.string().min(1, { message: 'Please select a user type' }),
  roleName: z.string().min(1, { message: 'Please enter a role title' }),
  roleDescription: z.string().min(1, { message: 'Please enter a description' }),
});

interface AddRoleFormProps {
  userRoleType: DropdownOption[];
}

export const AddRoleForm = (props: AddRoleFormProps) => {
  const form = useForm({ schema: addRoleModalSchema, mode: 'all' });

  const userRoleTypeOptions = toLabelValue(props.userRoleType, {
    labelKey: 'label',
    valueKey: 'value',
  });

  const { mutateAsync } = useRoleMutation();
  const { t } = useDynamicLocale();
  return (
    <Form
      form={form}
      onSubmit={async (data) => {
        await mutateAsync(data);
      }}
    >
      <div className="flex flex-col gap-4.5">
        <div>
          <Select
            label="rolesPrivileges.addRoleModal.userType"
            {...form.register('roleType')}
            placeholder={t('common.form.placeholder.select')}
            options={userRoleTypeOptions}
          />
        </div>

        <Input
          label="rolesPrivileges.addRoleModal.roleTitle"
          {...form.register('roleName')}
          placeholder={t('userManagement.rolesAndPrivileges.addNewRole.enterRole')}
        />
        <Textarea
          className="resize-none"
          {...form.register('roleDescription')}
          label="rolesPrivileges.addRoleModal.description"
          placeholder={t('userManagement.rolesAndPrivileges.addNewRole.writeSomething')}
        />
      </div>
    </Form>
  );
};
